import { CarteiraUsuarioResponse } from "./carteiraUsuarioResponse";
import { CarteiraBaseCampanhaResponse } from "./carteiraBaseCampanhaResponse";
import { CarteiraBaseResponse } from "./carteiraBaseResponse";

export const CARTEIRA_BASE_GET = 'CARTEIRA_BASE_GET';
export const CARTEIRA_BASE_UPDATE = 'CARTEIRA_BASE_UPDATE';
export const CARTEIRA_BASE_CAMPANHA_GET = 'CARTEIRA_BASE_CAMPANHA_GET';
export const GET_CATEIRA_USUARIO = 'GET_CATEIRA_USUARIO';

export interface CarteiraBaseState {
    CarteiraBase: CarteiraBaseResponse,
    CarteiraBaseCampanha: CarteiraBaseCampanhaResponse,
    CarteiraUsuario: CarteiraUsuarioResponse[],
}

export interface CarteiraBaseAction {
    type: typeof CARTEIRA_BASE_GET,
    payload: CarteiraBaseResponse
}

export interface CarteiraBaseUpdateAction {
    type: typeof CARTEIRA_BASE_UPDATE,
    payload: CarteiraBaseResponse
}

export interface CarteiraBaseCampanhaAction {
    type: typeof CARTEIRA_BASE_CAMPANHA_GET,
    payload: CarteiraBaseCampanhaResponse
}

export interface CarteiraUsuarioAction {
    type: typeof GET_CATEIRA_USUARIO,
    payload: CarteiraUsuarioResponse[]
}

export type CarteiraBaseActionTypes =
    CarteiraBaseAction |
    CarteiraBaseCampanhaAction |
    CarteiraUsuarioAction |
    CarteiraBaseUpdateAction